export const styles = () => ({
  genericContainer: {
    display: 'flex',
    width: 'max-content',
    margin: '12px 0px',
  },
})
